const da = {
  navigation: {
    button: "Tilføj nyt mål",
  },
  homepage: {
    headline: "Dashboard",
    description: "Oversigt over alle dine årlige mål, milepæle og ønsker ét sted.",
  },
  vision_board: {
    headline: "Vision board",
    description: "Visuel oversigt over dine mål for at holde dig motiveret og fokuseret.",
  },
  goals: {
    headline: "Mål",
    description: "Spor dine mål og vaner, og se dine fremskridt over tid.",
    not_found: "Mål ikke fundet",
    back_to_goals: "Tilbage til mål",
    details_headline: "Måldetaljer",
    details_description: "Se detaljer",
    edit_goal: "Rediger mål"
  },
  milestones: {
    headline: "Milepæle",
    description: "Spor daglige opgaver og skriv noter om din dag i dagbogen.",
  },
  wishlist: {
    headline: "Ønskeliste",
    description: "Organiser og hold styr på dine ønskede varer og fremtidige køb.",
  },
  notification: {
    headline: "Notifikationer",
    description: "Her finder du alle opdateringer.",
    empty: "Ingen notifikationer endnu."
  },  
  profile: {
    headline: "Profil",
    description: "Vis og administrer dine personlige oplysninger og indstillinger.",

    tab_1: "Personlige oplysninger",
    tab_1_description: "Opdater din profil, kontaktoplysninger og præferencer for at tilpasse din oplevelse.",
    tab_2: "Login og sikkerhed",
    tab_2_description: "Opdater din adgangskode og loginindstillinger.",
    tab_3: "Abonnement og betaling",
    tab_3_description: "Opdater din adgangskode og loginindstillinger.",
    card_title_login: "Loginoplysninger",
    card_description_login: "",
    card_title_pass: "Adgangskodedetaljer",
    card_description_pass: "",
    card_title_subscription: "Abonnementsoplysninger",
    card_description_subscription: "Opdater din adgangskode og loginindstillinger.",
    card_title_payment: "Betalingsoplysninger",
    card_description_payment: "",
    button: "Slet konto",

    popup: {
      delete_title: "Slet konto",
      delete_description: "Er du sikker på, at du vil slette din konto? Denne handling kan ikke fortrydes. Sletning af din konto vil også annullere dit abonnement.",
    },
  
    personal: {
      title: "Personlige detaljer",
      form: {
        label_name: "Fornavn",
        label_surname: "Efternavn",
        label_phone: "Telefonnummer",
        label_country: "Land",
        label_city: "By/Region",
        label_postal: "Postnummer",
        label_street: "Gade",
        label_username: "Brugernavn",
        label_email: "Email",
        label_old_pass: "Indtast gammel adgangskode",
        label_new_pass: "Indtast ny adgangskode",
        label_new_pass_repeat: "Gentag ny adgangskode",
        label_cardholder: "Kortholders navn",
        label_cardnumber: "Kortnummer",
        label_carddate: "Udløbsdato",
        label_cvv: "CVV / CVC (Kortverifikationskode)"
      }
    }
  },
  login: {
    headline: "Login",
    description: "Indtast dine oplysninger",
  },
  register: {
    headline: "Opret konto",
    description: "Indtast dine oplysninger",
    form: {
      label_email: "Email",
      placeholder_email: "info@niumi.dk",
      details_email: "Ingen spam, garanteret.",
      label_password: "Adgangskode",
      details_password: "Min 12 tegn",
      label_confirm_password: "Bekræft adgangskode",
      button_submit: "Start min gratis prøveperiode",
      button_resend: "Send bekræftelsesmail igen",
      subheadline_enter_details: "Indtast dine oplysninger",
      subheadline_confirm_email: "Bekræft din email",
      description_confirm_email: "Vi har sendt dig en bekræftelsesmail. Tjek venligst din indbakke og bekræft din emailadresse for at fortsætte.",
      text_already_registered: "Allerede registreret?",
      text_login: "Login",
      text_or: "eller",
      terms_text_prefix: "Ved at oprette en konto accepterer du vores",
      terms_link: "Servicevilkår",
      terms_text_and: "og",
      privacy_link: "Privatlivspolitik"
    },
    errors: {
      invalid_email: "Indtast en gyldig emailadresse",
      password_min_length: "Adgangskoden skal være mindst 12 tegn",
      password_uppercase: "Adgangskoden skal indeholde mindst ét stort bogstav",
      password_lowercase: "Adgangskoden skal indeholde mindst ét lille bogstav",
      password_number: "Adgangskoden skal indeholde mindst ét tal",
      password_special: "Adgangskoden skal indeholde mindst ét specialtegn",
      confirm_password_required: "Bekræft venligst din adgangskode",
      passwords_do_not_match: "Adgangskoderne matcher ikke",
      captcha_required: "Bekræft venligst, at du ikke er en robot.",
      registration_failed: "Registrering mislykkedes. Prøv venligst igen.",
      verification_email_resent: "Bekræftelsesmail sendt igen. Tjek venligst din indbakke.",
      unable_to_resend: "Kunne ikke sende bekræftelsesmail igen.",
      terms_required: "Du skal acceptere Servicevilkår og Privatlivspolitik"
    },
  },
  forgot_password: {
    headline: "Glemt adgangskode",
    description: "Indtast din e-mail for at nulstille adgangskode.",
  },
  start_message: {
    headline: "Start din rejse!",
    description: "Det ser ud til, at du ikke har nogen mål endnu. Tilføj dit første mål og kickstart et fantastisk år!",
  },
  logout: {
    headline: "Log ud",
  },
  help_center: {
    headline: "Hjælpecenter",
  },
  card_quote: {
    headline: "Citat",
    description: "Et citat til at inspirere og forme dit kommende år",
    popup: {
      delete_title: "Slet",
      delete_description: "Er du sikker på, at du vil slette dette citat permanent?",
      edit_title: "Rediger citat",
      add_title: "Skriv citat for"
    },
    form: {
      label: "Citat",
      placeholder: "Start hvor du er. Brug det du har. Gør hvad du kan."
    }
  },
  card_theme: {
    headline: "Tema",
    description: "Dit primære fokusområde for dette år",
    popup: {
      delete_title: "Slet",
      delete_description: "Er du sikker på, at du vil slette dette tema permanent?",
      edit_title: "Rediger tema",
      add_title: "Skriv tema for"
    },
    form: {
      label: "Tema",
      placeholder: "Prioritering af vækst i mit professionelle liv — opkvalificering, netværk og modige skridt fremad."
    }
  },  
  card_letter: {
    headline: "Brev til dit fremtidige jeg",
    description: "Skriv et brev med refleksioner over din udvikling for det kommende år",
    button: "Åbn brevet inden udgangen af",
    popup: {
      delete_title: "Slet",
      delete_description: "Er du sikker på, at du vil slette dette brev permanent?",
      edit_title: "Rediger brev",
      add_title: "Skriv brev til dit fremtidige jeg",
      view_title: "Brev til dit fremtidige jeg"
    },
    form: {
      label_title: "Overskrift",
      placeholder_title: "Til den person, jeg bliver — Et brev til dig",
      label_text: "Brev",
      placeholder_text: "Jeg vil have dig til at vide, at jeg gør mit bedste for at være den bedste version af mig selv, og jeg håber, du har fortsat den rejse. Uanset hvor livet har ført dig hen, så husk de værdier, der altid har været vigtige for dig. Glem ikke, hvad der virkelig betyder noget.",
      label_link: "Link"
    }
  },
  card_note: {
    headline: "Daglige tanker",
    description: "Et rum til daglig refleksion og udvikling",
    popup: {
      delete_title: "Slet",
      delete_description: "Er du sikker på, at du vil slette denne note permanent?",
      edit_title: "Rediger note",
      add_title: "Skriv daglig note",
      view_title: "Se daglig note"
    },
    form: {
      label_date: "Dato",
      label_title: "Overskrift",
      placeholder_title: "De små ting, der gjorde dagen i dag",
      label_text: "Note",
      placeholder_text: "I dag lærte jeg noget om mig selv. Det fik mig til at indse, hvor meget jeg er vokset."
    }
  },
  card_goal: {
    headline: "Mål",
    description: "Hold fokus og på rette spor med dine mål"
  },
  card_progress: {
    headline: "Fremskridt",
    description: "Spor dine opgaver og fejre dine sejre"
  },
  card_milestone: {
    headline: "Milepæle",
    description: "Hold styr på daglige opgaver",
    fallback_text: "Ingen opgaver planlagt for i dag. Slap af — du er på rette vej!",
    popup: {
      delete_title: "Slet",
      delete_description: "Er du sikker på, at du vil slette denne milepæl permanent?",
      edit_title: "Rediger milepæl",
    },
    form: {
      label_title: "Titel",
      label_deadline: "Deadline",
      label_status: "Fuldført"
    }
    

  },
  card_wishlist: {
    headline: "Ønskeliste",
    description: "Hold fokus og bliv på sporet med dine mål",
    button: "Tilføj ønske",
    button_file: "Vælg en fil",

    popup: {
      delete_title: "Slet",
      delete_description: "Er du sikker på, at du vil slette dette ønske permanent?",
      edit_title: "Rediger ønske",
      add_title: "Tilføj ønske"
    },
    form: {
      label_title: "Mit ønske",
      placeholder_title: "Ny MacBook Pro",
      label_img: "Upload et billede",
      label_link: "Link",
      placeholder_link: "https://example.com",
      label_price: "Pris",
      placeholder_price: "299",
      label_currency: "Valuta",
      placeholder_currency: "DKK"
    }
  },  
  dropdown: {
    add: "Tilføj",
    edit: "Rediger",
    delete: "Slet",
    view: "Vis",
    view_all: "Vis alle",
    cancel: "Anullere",
    close: "Luk",
    save: "Gem",
    update: "Opdater",
    link_shop: "Link til butik",
    bought: "Købt",
    read_more: "Læs mere"
  },
  tab: {
    title_1: "Mål og fremskridt",
    title_2: "Milepæle og journal",
    title_3: "Ønskeliste"
  },
  metrics: {
    total: "Samlede mål",
    progress: "I gang",
    completed: "Fuldførte",
    fav: "Mit store fokus for",
    popup: {
      edit_title: "Rediger mit store fokus for",
      edit_description: "Vælg ét ultimativt fokus for året og gør det til din prioritet"
    }    
  },
  calendar: {
    upcoming: "Kommende",
    completed: "Fuldførte",
    today: "I dag",
    mon: "Man",
    tue: "Tir",
    wed: "Ons",
    thu: "Tors",
    fri: "Fre",
    sat: "Lør",
    sun: "Søn"
  },
    addgoal: {
      milestone_title: "Milepæle",
      milesone_description: "Opdel dit mål i praktiske opgaver",
      button_milestone: "Tilføj milepæl",
    
      toggle_title: "Hvordan sætter du dine S.M.A.R.T-mål?",
    
      form: {
        label_title: "Sæt mål",
        placeholder_title: "Rejs til Paris i en uge",
        label_img: "Upload et billede, der repræsenterer målet",
        label_deadline: "Sæt deadline",
        placeholder_deadline: "Vælg eller skriv en deadline fx: 2026, 2027 osv.",
        label_category: "Vælg kategori",
        placeholder_category: "Vælg eller skriv kategori fx: Sundhed, Karriere, Økonomi, Personlig udvikling osv.",
        label_fav: "Sæt som årets mål",
        placeholder_fav: "Den ene store ting, jeg arbejder hen imod:",
        label_milestone_title: "Sæt milepæl",
        label_milestone_placeholder: "Book flybilletter",
        label_milestone_deadline: "Sæt deadline",
        label_milestone_repeat: "Gentag",
        label_milestone_select: "Vælg en mulighed",
        label_milestone_repeat_1: "Dagligt",
        label_milestone_repeat_2: "Ugentligt",
        label_milestone_repeat_3: "Månedligt",
      }
    }
    
  
  
  
  
  
};

export default da;
